// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.31.1
// source: Common/DeviceRegistrationEvents.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "common.events";

/** Device registration events */
export interface DeviceRegistrationVerificationEvent {
  success: boolean;
  status: string;
  expiresAt: number;
}

export interface DeviceRegistrationConfirmationEvent {
  success: boolean;
}

export interface DeviceRegistrationCancelationEvent {
  success: boolean;
}

export interface DeviceChangedEvent {
  deviceId: string;
  secretApiKey: string;
  institutionId?: string | undefined;
}

function createBaseDeviceRegistrationVerificationEvent(): DeviceRegistrationVerificationEvent {
  return { success: false, status: "", expiresAt: 0 };
}

export const DeviceRegistrationVerificationEvent = {
  encode(message: DeviceRegistrationVerificationEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    if (message.expiresAt !== 0) {
      writer.uint32(24).int64(message.expiresAt);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeviceRegistrationVerificationEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceRegistrationVerificationEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.status = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.expiresAt = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceRegistrationVerificationEvent {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : 0,
    };
  },

  toJSON(message: DeviceRegistrationVerificationEvent): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.expiresAt !== 0) {
      obj.expiresAt = Math.round(message.expiresAt);
    }
    return obj;
  },

  create(base?: DeepPartial<DeviceRegistrationVerificationEvent>): DeviceRegistrationVerificationEvent {
    return DeviceRegistrationVerificationEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeviceRegistrationVerificationEvent>): DeviceRegistrationVerificationEvent {
    const message = createBaseDeviceRegistrationVerificationEvent();
    message.success = object.success ?? false;
    message.status = object.status ?? "";
    message.expiresAt = object.expiresAt ?? 0;
    return message;
  },
};

function createBaseDeviceRegistrationConfirmationEvent(): DeviceRegistrationConfirmationEvent {
  return { success: false };
}

export const DeviceRegistrationConfirmationEvent = {
  encode(message: DeviceRegistrationConfirmationEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeviceRegistrationConfirmationEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceRegistrationConfirmationEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceRegistrationConfirmationEvent {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: DeviceRegistrationConfirmationEvent): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<DeviceRegistrationConfirmationEvent>): DeviceRegistrationConfirmationEvent {
    return DeviceRegistrationConfirmationEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeviceRegistrationConfirmationEvent>): DeviceRegistrationConfirmationEvent {
    const message = createBaseDeviceRegistrationConfirmationEvent();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseDeviceRegistrationCancelationEvent(): DeviceRegistrationCancelationEvent {
  return { success: false };
}

export const DeviceRegistrationCancelationEvent = {
  encode(message: DeviceRegistrationCancelationEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeviceRegistrationCancelationEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceRegistrationCancelationEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceRegistrationCancelationEvent {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: DeviceRegistrationCancelationEvent): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<DeviceRegistrationCancelationEvent>): DeviceRegistrationCancelationEvent {
    return DeviceRegistrationCancelationEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeviceRegistrationCancelationEvent>): DeviceRegistrationCancelationEvent {
    const message = createBaseDeviceRegistrationCancelationEvent();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseDeviceChangedEvent(): DeviceChangedEvent {
  return { deviceId: "", secretApiKey: "", institutionId: undefined };
}

export const DeviceChangedEvent = {
  encode(message: DeviceChangedEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.secretApiKey !== "") {
      writer.uint32(26).string(message.secretApiKey);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeviceChangedEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceChangedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.secretApiKey = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceChangedEvent {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      secretApiKey: isSet(object.secretApiKey) ? globalThis.String(object.secretApiKey) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: DeviceChangedEvent): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.secretApiKey !== "") {
      obj.secretApiKey = message.secretApiKey;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeviceChangedEvent>): DeviceChangedEvent {
    return DeviceChangedEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeviceChangedEvent>): DeviceChangedEvent {
    const message = createBaseDeviceChangedEvent();
    message.deviceId = object.deviceId ?? "";
    message.secretApiKey = object.secretApiKey ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
